export const fmtMoney = (v) => {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  const sign = v < 0 ? "-" : "";
  const n = Math.abs(v);
  return `${sign}$${n.toFixed(2)}`;
};

export const fmtSigned = (v) => {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  const sign = v > 0 ? "+" : v < 0 ? "-" : "";
  return `${sign}$${Math.abs(v).toFixed(2)}`;
};

export const fmtPct = (v, digits = 1) => {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  return `${v.toFixed(digits)}%`;
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  // Treat "YYYY-MM-DD" as a calendar date in LOCAL time (US market convention),
  // not as midnight UTC. Otherwise users in US timezones see the previous day.
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  const d = m
    ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
    : new Date(iso);
  return d.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "2-digit" });
};

export const fmtNum = (v) => {
  if (v === null || v === undefined) return "—";
  return new Intl.NumberFormat("en-US").format(v);
};

// Return css class for a candidate cell given category
export const cellClass = (category) => {
  switch (category) {
    case "credit_strong":
      return "cell-credit-strong";
    case "credit_light":
      return "cell-credit-light";
    case "credit_marginal":
      return "cell-credit-marginal";
    case "debit":
      return "cell-debit";
    default:
      return "cell-neutral";
  }
};
